'use es6';

export const RESPONSIVE_EMAIL = 'responsive_email';